/**
 * @generated SignedSource<<a185053b10bb91e77c8b458b2156e5f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type ConnectedAccountCard_storeUser$data = {
  readonly id: string;
  readonly role: Roles;
  readonly user: {
    readonly email: string;
  };
  readonly " $fragmentType": "ConnectedAccountCard_storeUser";
};
export type ConnectedAccountCard_storeUser$key = {
  readonly " $data"?: ConnectedAccountCard_storeUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectedAccountCard_storeUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConnectedAccountCard_storeUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreUser",
  "abstractKey": null
};

(node as any).hash = "1486dfc05bf56f3e3134c708a9ca6c5b";

export default node;
